import { View, Text, Switch, ViewStyle } from "react-native";
import { Control, Controller } from "react-hook-form";
import { colors } from "../../../theme";
import { SwitchOption, JobPreferencesFormData } from "./types";

const otherPreferences: SwitchOption[] = [{ fieldName: "openToSeasonal", label: "Include Seasonal Positions" }];

interface OtherPreferencesProps {
  control: Control<JobPreferencesFormData>;
  style?: ViewStyle; // Required for space-y-1 in root component.
}

const OtherPreferences = ({ control, style }: OtherPreferencesProps) => (
  <View className="bg-white px-6 py-8" {...{ style }}>
    <Text className="text-large-normal text-ink-darkest font-700 mb-4">Other Preferences</Text>
    <View className="divide-sky-lighter divide-y">
      {otherPreferences.map((preference) => (
        <View key={preference.fieldName} className="flex flex-row justify-between items-center py-5">
          <Text className="text-regular-tight text-ink-darkest">{preference.label}</Text>
          <Controller
            name={preference.fieldName}
            control={control}
            defaultValue={false}
            render={({ field: { onChange, value } }) => (
              <Switch
                {...{
                  trackColor: { true: colors.primary.DEFAULT },
                  onValueChange: onChange,
                  value,
                }}
              />
            )}
          />
        </View>
      ))}
    </View>
  </View>
);

export default OtherPreferences;
